import { getProgressPercentage } from './get-progress-percentage';

export const getAudioData = (audio) => ({
  duration: audio.duration,
  currentTime: audio.currentTime,
  progressPercentage: getProgressPercentage(audio.duration, audio.currentTime),
});
